import { BaseModel } from "@blue-chip/core";
import Currency from "./Currency";
import Project from "./Project";

export default class ProjectCurrency extends BaseModel {
  static get belongsTo() {
    return [Project, Currency];
  }
}
